// Makes and reads the Collab link, the address that lets a person join a place, and makes the
// random IDs Collab uses.
//
// The Collab link: `{collab}#token={token}`, the token percent-encoded, in the address's fragment
// so that it stays in the browser; and random IDs.

/**
 * The token of the Collab link in `hash` (with or without its `#`), or undefined when it holds none:
 * a token without a person's ID, as `tablebox token` makes it, which names its room and its Relays.
 * Whoever opens the Collab link connects with it, each tab with the ID the SDK makes for it.
 */
export function parseCollabLink(hash: string): string | undefined {
  return new URLSearchParams(hash.replace(/^#/u, '')).get('token')?.trim() || undefined;
}

/** The Collab link of `token` for `base`, Collab's address without a fragment. */
export function formatCollabLink(base: string, token: string): string {
  return `${base}#token=${encodeURIComponent(token)}`;
}

/** 128 random bits as 22 characters of unpadded base64url: the ID of a note or a shared file. */
export function newId(): string {
  const values = crypto.getRandomValues(new Uint8Array(16));
  return btoa(String.fromCharCode(...values)).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/u, '');
}
